import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useCallback, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { PageHeader, PageHeaderWithBack } from "@/components/common";
import { useAuth } from "@/context/AuthContext";
import { shoppingCentresService } from "@/api/services/shoppingCentres.service";
import { ShoppingCentreDetailsForm } from "./components";
import styles from "./ShoppingCentreEdit.module.css";
export const ShoppingCentreEdit = () => {
    const { centreId } = useParams();
    const navigate = useNavigate();
    const { user } = useAuth();
    const saveHandlerRef = useRef(null);
    const [centre, setCentre] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [saving, setSaving] = useState(false);
    const fetchCentre = useCallback(async () => {
        if (!centreId)
            return;
        try {
            setLoading(true);
            setError(null);
            const response = await shoppingCentresService.getShoppingCentre(centreId);
            setCentre(response.data);
        }
        catch (err) {
            setError("Failed to load shopping centre");
            console.error("Error fetching shopping centre:", err);
        }
        finally {
            setLoading(false);
        }
    }, [centreId]);
    useEffect(() => {
        fetchCentre();
    }, [fetchCentre]);
    const handleSave = async (dto) => {
        if (!centreId)
            return undefined;
        await shoppingCentresService.updateShoppingCentre(centreId, dto);
        await fetchCentre();
        return undefined;
    };
    const handleBackClick = () => {
        navigate(-1);
    };
    const handleSaveClick = async () => {
        if (saveHandlerRef.current) {
            setSaving(true);
            try {
                await saveHandlerRef.current();
            }
            catch (err) {
                console.error("Error saving:", err);
            }
            finally {
                setSaving(false);
            }
        }
    };
    if (loading) {
        return (_jsxs("div", { className: styles.container, children: [_jsx(PageHeader, { userName: user?.name || "User", userEmail: user?.email || "" }), _jsx(PageHeaderWithBack, { title: "Edit Shopping Centre", onBack: handleBackClick, breadcrumb: "Shopping Centres/Edit Shopping Centre" }), _jsx("div", { className: styles.loading, children: "Loading shopping centre..." })] }));
    }
    if (error || !centre) {
        return (_jsxs("div", { className: styles.container, children: [_jsx(PageHeader, { userName: user?.name || "User", userEmail: user?.email || "" }), _jsx(PageHeaderWithBack, { title: "Edit Shopping Centre", onBack: handleBackClick, breadcrumb: "Shopping Centres/Edit Shopping Centre" }), _jsx("div", { className: styles.error, children: error || "Shopping centre not found" })] }));
    }
    return (_jsxs("div", { className: styles.container, children: [_jsx(PageHeader, { userName: user?.name || "User", userEmail: user?.email || "" }), _jsx(PageHeaderWithBack, { title: "Edit Shopping Centre", subtitle: centre.scName ?? undefined, onBack: handleBackClick, breadcrumb: "Shopping Centres/Edit Shopping Centre" }), _jsxs("div", { className: styles.contentArea, children: [_jsx(ShoppingCentreDetailsForm, { centre: centre, onSave: handleSave, saveHandlerRef: saveHandlerRef }), _jsx("div", { className: styles.summaryActions, children: _jsx("button", { className: styles.saveButton, onClick: handleSaveClick, disabled: saving, children: saving ? "Saving..." : "Save" }) })] })] }));
};
